<template>
  <v-container
    id="data-tables"
    tag="section"
    class="px-0"
  >
    <valkyrie-list
      :list-data="listData"
      :pagination="orgUsersPagination"
      :pagination-text="paginationText"
      :list-name="'Users'"
      :headers.sync="headers"
      :is-loading="loading"
      :rows-selectable="(item) => item.id !== currentUser.id && item.name !== ''"
      @update-pagination="handleUpdatePagination"
      @select-row="selectRow"
    >
      <template v-slot:list-header>
        <div class="d-flex justify-space-between">
          <v-btn
            class="btn-with-icon"
            color="primary"
            :to="`/organizations/${$route.params.orgId}/add_user`"
          >
            <v-icon>
              $faPlus
            </v-icon>
            Invite User
          </v-btn>
          <div
            v-if="paginationText"
            class="pr-6 top-pagination"
          >
            <span v-if="!paginationText.includes('undefined')">{{ paginationText }}</span>
            <v-skeleton-loader
              v-else
              loading
              type="chip"
            />
          </div>
        </div>
      </template>
      <!-- eslint-disable-next-line -->
      <template #item.nameLink="{item}">
        <span
          v-if="!item.userOnboarded"
          style="color:#929292"
        >Invite Sent to {{ item.email }}</span>
        <span
          v-else
          :style="item.id !== currentUser.id && 'color:#456E6C'"
        >{{ item.name }}</span>
      </template>
      <!-- eslint-disable-next-line -->
      <template #item.userOrgsRole="{ item }">
        <div
          v-for="org of item.orgs"
          :key="org.ID"
        >
          <span v-if="org.id === orgId">{{ org.role }}</span>
        </div>
      </template>
      <!-- eslint-disable-next-line -->
      <template #item.resendInvite="{ item }">
        <v-btn
          v-if="!item.userOnboarded"
          color="#456E6C"
          text
          @click="resendInvite(item)"
        >
          Resend Invite
        </v-btn>
      </template>
      <template slot="empty-state">
        <empty-state
          icon="$faUsers"
          text="No users found"
        />
      </template>
    </valkyrie-list>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import listMixin from '@/helpers/list-mixin'
  import listControllerMixin from '@/helpers/list-controller-mixin'
  import ValkyrieList from '@/components/ValkyrieList.vue'
  import EmptyState from '../../components/base/EmptyState.vue'
  import paginationHelper from '@/helpers/pagination-helper'

  export default {
    name: 'OrgUsersList',
    components: { ValkyrieList, EmptyState },
    mixins: [listMixin, listControllerMixin],
    props: {
      searchable: {
        type: Boolean,
        default: false,
      },
      exportable: {
        type: Boolean,
        default: false,
      },
      filterable: {
        type: Boolean,
        default: false,
      },
      hasFilters: {
        type: Boolean,
        default: false,
      },
      filterBy: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      loading: false,
      search: '',
      payload: {
        listType: 'user',
        fileName: 'users.csv',
      },
      headers: [
        {
          text: 'Username',
          value: 'nameLink',
        },
        {
          text: 'Role',
          value: 'userOrgsRole',
        },
        {
          text: '',
          value: 'resendInvite',
          width: '20%',
        },
      ],
    }),
    computed: {
      ...mapGetters('Users', [
        'totalUsers',
        'currentUser',
      ]),
      orgId () {
        return Number.parseInt(this.$route.params.orgId)
      },
      paginationText () {
        return paginationHelper(this.pageNum, this.perPage, this.totalUsers)
      },
      staticFilters () {
        return [{ key: 'organization_id', operator: '=', value: `${this.orgId}` }]
      },
      listAPIPath () {
        return `${this.$store.state.baseURL}/user/list`
      },
      orgUsersPagination () {
        return { ...this.pagination, total: this.totalUsers }
      },
    },
    watch: {
      orgId (newOrg) {
        if (newOrg) this.initializeOrgUsersList()
      },
    },
    created () {
      this.initializeOrgUsersList()
    },
    destroyed () { clearInterval(this.timeout) },
    methods: {
      initializeOrgUsersList () {
        this.fetchList(this.listAPIPath)
          .then((res) => this.$store.commit('Users/updateTotalUsers', res.data.pagination.total))
      },
      selectRow (item) {
        if (item.userOnboarded) {
          this.$store.commit('Users/setUserData', item)
          const index = (this.listData.findIndex(user => parseInt(user.id) === parseInt(item.id)))
          const listingNumber = (this.perPage) * (this.pageNum - 1) + (index + 1)
          if (this.detail) return
          const checkRoute = this.$router.resolve({ path: `/users/${item.id}` })
          if (checkRoute.resolved.name !== '404 Error') {
            this.$router.push({
              path: `/organizations/${this.$route.params.orgId }/users/${item.id}`,
              query: { index: listingNumber },
            })
          }
        }
      },
      resendInvite (user) {
        const orgRole = user.orgs.find(org => org.id === this.orgId)
        const payload = {
          orgUser: {
            orgId: Number.parseInt(this.orgId),
            orgRoleName: orgRole.role,
          },
          user: {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email.trim(),
            phone: user.phone,
            role: 'external',
          },
        }
        this.$store.dispatch('Organizations/resendInvite', payload)
          .then((res) => {
            if (res.data && res.data.data && res.data.data.id) {
              const toastPayload = { type: 'success', text: 'Successfully resent invitation' }
              this.$store.dispatch('updateMessages', toastPayload, { root: true })
            }
          })
      },
    },
  }
</script>
<style lang="scss">
.btn-with-icon {
  padding:0 1rem !important;
  height:40px;
  width:140px;
  .svg-inline--fa {
    height:14px !important;
    width: 16px !important;
    margin-right:10px;
  }
  .v-btn__content {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 1px;
  }
}
</style>
